import { meContract } from '@mntn/api-contracts/flight-deck/v1/me'
import { SessionSync } from '@mntn/session-sync'
import { useCallback } from 'react'
import { useFlightDeckTsRestClient } from '@/flight-deck-api/ts-rest'
import { queryClient } from '@/providers/api-client/flight-deck-api-client'

export function FlightDeckSessionSync() {
  const meClient = useFlightDeckTsRestClient(meContract)

  /**
   * `keepalive: true` is critical here: premier triggers a full window reload
   * right after an advertiser switch broadcasts. A normal in-flight fetch would
   * be cancelled on unload; keepalive lets the browser deliver the POST after
   * the page is gone so select-api still fans out to other origins.
   */
  const notifySessionChanged = useCallback(
    async (changedAdvertiserId: number) => {
      queryClient.clear()

      const response = await meClient.sessionChanged({
        body: { advertiserId: changedAdvertiserId },
        fetchOptions: { keepalive: true },
      })
      if (response.status !== 200) {
        throw new Error(`flight-deck session-changed POST failed: ${response.status}`)
      }
    },
    [meClient],
  )

  return <SessionSync notifySessionChanged={notifySessionChanged} />
}
